import { hasLocationScope } from 'scopes/helpers';
import { useScopes } from './useScopes';

export function useHasLocationScope(scope) {
  return hasLocationScope(scope)(useScopes().scopeDetails);
}
